module.exports = __webpack_public_path__ + "img/2021_03_dande_nijojo_fin_web.63d3b462.jpg";